import "../../css/master.css";
import "../../css/app.css";
import "../../css/custom.css";
import MainComponent from "./main_component";
import SideBar from "../../sidebar/sidebar";
import Loader from '../../loader/loader';
import { useAtom, atom } from 'jotai';
import { useLocation } from "react-router-dom";
import CheckUserInfoAgreement from "../../checkUserInfoAgreement";

const isLoadingAtom = atom(false);

function FileInfoConfirm() {

    const location = useLocation();
    const [isLoading, setIsLoading] = useAtom(isLoadingAtom);

    if (!location.state) {
        window.location.replace("/inquiry_status");
    }

    const handleLoading = (set) => {

        setIsLoading(set)
    }

    return (
        <>
            <CheckUserInfoAgreement />
            {isLoading === true ? <Loader /> : null}
            <div className="header-utility">
                <div className="header-utility-inner">
                    <ul className="header-utility-list sub">
                    </ul>
                </div>
            </div>
            <main className="site-main">
                <section className="sct-primary">
                    <div className="ls-row str-column" id="ls-row-3-col-1-row-2">
                        <SideBar />
                        <MainComponent handleLoading={handleLoading} />
                    </div>
                </section>
            </main>
        </>
    );
}


export default FileInfoConfirm;